import { render, staticRenderFns } from "./loader.component.vue?vue&type=template&id=3e91feea&scoped=true"
import script from "./loader.component.vue?vue&type=script&lang=js"
export * from "./loader.component.vue?vue&type=script&lang=js"
import style0 from "./loader.component.vue?vue&type=style&index=0&id=3e91feea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e91feea",
  null
  
)

export default component.exports